<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>

                <CCardBody>
                    <AssistantTabLinks />

                    <AssistantUpsertForm
                        class="mt-4"
                        :entity="entity"
                        @success="$router.push(`/assistants/${$route.params.id}`)"
                        @deleted="$router.push('/assistants')"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import to from 'await-to-js'

    import AssistantTabLinks from '@/components/assistant/AssistantTabLinks'
    import AssistantUpsertForm from '@/components/assistant/AssistantUpsertForm'

    export default {
        components: {
            AssistantTabLinks,
            AssistantUpsertForm,
        },

        data: () => ({
            entity: undefined,
        }),

        async created() {
            await this.fetch()
        },

        methods: {
            async fetch() {
                const id = this.$route.params.id

                const [error, result] = await to(this.axios.get(`/assistants/${id}`))
                this.entity = result.data

                if (error) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            }
        }
    }
</script>
